import React from "react";
import { Phone, MapPin, MessageCircle } from "lucide-react";
import { ScrollAnimation } from "../ScrollAnimation";

export default function Contact() {
  return (
    <section id="contato" className="py-20 sm:py-24 px-4 sm:px-6 lg:px-8 bg-white">
      <div className="max-w-6xl mx-auto">
        <ScrollAnimation animation="fade-up">
          <span className="font-sans text-sm font-semibold text-[#C2A44A] tracking-wider uppercase mb-3 block text-center">Contato</span>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={100}>
          <h2 className="font-sans text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-[#204613] mb-8 text-balance text-center leading-tight">
            Pronta(o) para dar o próximo passo? Fale com a gente!
          </h2>
        </ScrollAnimation>
        <ScrollAnimation animation="fade-up" delay={200}>
          <p className="font-serif text-base sm:text-lg leading-relaxed text-[#4a4a4a] mb-12 text-center max-w-2xl mx-auto">
            Estamos aqui para acolher, escutar e orientar você em cada etapa da sua jornada. Se quiser agendar uma consulta, tirar dúvidas ou saber mais sobre nossos tratamentos, é só preencher o formulário ou falar direto pelo WhatsApp.
          </p>
        </ScrollAnimation>

        <div className="max-w-2xl mx-auto">
          <ScrollAnimation animation="fade-up" delay={300}>
            <div className="flex flex-col gap-6">
              <h3 className="font-sans text-xl sm:text-2xl font-semibold text-[#204613] text-center">Entre em contato:</h3>

              <a
                href="https://wa.me/5548992100333"
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-4 bg-[#25D366]/10 border border-[#25D366]/30 rounded-2xl p-5 sm:p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-[#25D366]/20 flex items-center justify-center flex-shrink-0">
                  <MessageCircle className="w-7 h-7 text-[#25D366]" />
                </div>
                <div>
                  <p className="font-sans font-semibold text-[#204613] mb-1">WhatsApp</p>
                  <p className="font-serif text-[#698658]">+55 48 99210-0333</p>
                </div>
              </a>

              <a
                href="tel:+5548992100333"
                className="flex items-center gap-4 bg-[#f5f0e4] border border-[#C2A44A]/30 rounded-2xl p-5 sm:p-6 hover:shadow-lg hover:-translate-y-0.5 transition-all duration-300"
              >
                <div className="w-14 h-14 rounded-2xl bg-[#C2A44A]/20 flex items-center justify-center flex-shrink-0">
                  <Phone className="w-7 h-7 text-[#C2A44A]" />
                </div>
                <div>
                  <p className="font-sans font-semibold text-[#204613] mb-1">Telefone</p>
                  <p className="font-serif text-[#698658]">+55 48 99210-0333</p>
                </div>
              </a>

              <div className="bg-[#ACC996]/10 border border-[#ACC996]/25 rounded-2xl p-5 sm:p-6">
                <div className="flex items-start gap-4">
                  <div className="w-14 h-14 rounded-2xl bg-[#698658]/15 flex items-center justify-center flex-shrink-0">
                    <MapPin className="w-7 h-7 text-[#698658]" />
                  </div>
                  <div>
                    <p className="font-sans font-semibold text-[#204613] mb-2">Endereço</p>
                    <p className="font-serif text-[#4a4a4a] leading-relaxed">
                      Square SC<br />
                      Rod Jose Carlos Daux, 5500<br />
                      Torre Campeche A sl 316<br />
                      Bairro Saco Grande - Florianópolis/SC<br />
                      CEP: 88032-005
                    </p>
                  </div>
                </div>
              </div>

              <div className="bg-[#f5f0e4] border-l-4 border-[#C2A44A] rounded-xl p-5 mt-2">
                <p className="font-serif text-base text-[#4a4a4a] leading-relaxed">
                  <strong className="text-[#204613]">Atendimento presencial e online.</strong>
                </p>
              </div>
            </div>
          </ScrollAnimation>
        </div>

        <div className="mt-16 sm:mt-20">
          <ScrollAnimation animation="fade-up" delay={500}>
            <h3 className="font-sans text-2xl sm:text-3xl font-bold text-[#204613] mb-8 text-center">Nossa Localização</h3>
          </ScrollAnimation>

          <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 sm:gap-8">
            <ScrollAnimation animation="fade-right" delay={600}>
              <div className="relative h-64 sm:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-lg">
                <img
                  src="https://hebbkx1anhila5yf.public.blob.vercel-storage.com/8sfleltdj2lcx34n.webp-GcoEPm5wifzlvujSToClWvcg5hTVyp.webp"
                  alt="Square SC - Complexo empresarial em Florianópolis"
                  className="w-full h-full object-cover"
                />
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4 sm:p-6">
                  <p className="font-sans font-semibold text-white text-lg">Square SC</p>
                  <p className="font-serif text-white/90 text-sm">Rod. José Carlos Daux, 5500 - Florianópolis</p>
                </div>
              </div>
            </ScrollAnimation>

            <ScrollAnimation animation="fade-left" delay={700}>
              <div className="relative h-64 sm:h-80 lg:h-96 rounded-2xl overflow-hidden shadow-lg">
                <iframe
                  src="https://www.google.com/maps?q=Square+SC,+Rod.+Jos%C3%A9+Carlos+Daux,+5500,+Florian%C3%B3polis,+SC&output=embed"
                  width="100%"
                  height="100%"
                  style={{ border: 0 }}
                  allowFullScreen
                  loading="lazy"
                  referrerPolicy="no-referrer-when-downgrade"
                  title="Localização Mesquita Psiquiatria"
                  className="rounded-2xl"
                />
              </div>
              <a
                href="https://www.google.com/maps/search/?api=1&query=Square+SC+Rod+Jos%C3%A9+Carlos+Daux+5500+Florian%C3%B3polis+SC"
                target="_blank"
                rel="noopener noreferrer"
                className="mt-4 inline-flex items-center justify-center gap-2 w-full px-6 py-3 bg-[#204613] text-white rounded-xl font-sans font-semibold text-base hover:bg-[#2d5a1a] transition-all duration-300 shadow-lg hover:shadow-xl"
              >
                <MapPin className="w-5 h-5" />
                Traçar Rotas
              </a>
            </ScrollAnimation>
          </div>
        </div>
      </div>
    </section>
  );
}
